import { format, getISOWeek } from 'date-fns';
import { fi } from 'date-fns/locale';

// apu: avain reservationsByDay:lle
export function dayKey(date) {
  return format(date, 'eee dd.MM.yyyy', { locale: fi });
}

// Otsikko: "Ma 25.08.2025"
export function displayDay(date) {
  const dd = ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La']; // 0=Su..6=La
  return `${dd[date.getDay()]} ${format(date, 'dd.MM.yyyy', { locale: fi })}`;
}

// Mobiilichip: "Ma" + "13.04."
export function mobileDayParts(date) {
  const dd = ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'];
  return {
    dow: dd[date.getDay()],
    date: format(date, 'dd.MM.', { locale: fi }),
  };
}

// ---- Sulkujen apufunktiot ----
export function parseDateOrNull(s) {
  if (!s) return null;
  return new Date(`${s}T00:00:00`);
}

export function timeToHour(s) {
  if (!s) return 0;
  const n = parseInt(String(s).split(':')[0], 10);
  return Number.isFinite(n) ? n : 0;
}

export function startOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
}

/**
 * Palauttaa { blocked: boolean, title?: string } annetulle slotille
 * Tukee repeat: 'none' | 'weekly' | 'biweekly' | 'monthly'
 * - none: jatkuva jakso [startDate@startTime .. endDate@endTime)
 * - weekly: sama viikonpäivä, aikaväli, toistuu kunnes untilDate (tai endDate jos ei untilDatea)
 * - biweekly: kuten weekly, mutta vain joka toinen viikko anchorista
 * - monthly: sama päivä kuukaudessa, aikaväli, toistuu kunnes untilDate
 */
export function isSlotBlockedBy(block, dateObj, hour) {
  if (block?.enabled === false) return { blocked: false };

  const sd = parseDateOrNull(block.startDate);
  const ed = parseDateOrNull(block.endDate);
  if (!sd || !ed) return { blocked: false };

  const sh = timeToHour(block.startTime || '00:00');
  const eh = timeToHour(block.endTime || '01:00');
  const repeat = block.repeat || 'none';
  const until = parseDateOrNull(block.untilDate) || ed;
  const title = block.title || 'Suljettu';

  const slotStart = new Date(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate(),
    hour,
    0,
    0,
    0
  );

  const hourInRange = (h) => h >= sh && h < Math.max(eh, sh + 1);

  if (repeat === 'none') {
    const rangeStart = new Date(
      sd.getFullYear(),
      sd.getMonth(),
      sd.getDate(),
      sh,
      0,
      0,
      0
    );
    const rangeEnd = new Date(
      ed.getFullYear(),
      ed.getMonth(),
      ed.getDate(),
      eh,
      0,
      0,
      0
    );

    if (slotStart >= rangeStart && slotStart < rangeEnd) {
      return { blocked: true, title };
    }
    return { blocked: false };
  }

  if (
    startOfDay(slotStart) < startOfDay(sd) ||
    startOfDay(slotStart) > startOfDay(until)
  ) {
    return { blocked: false };
  }

  if (repeat === 'weekly' || repeat === 'biweekly') {
    if (slotStart.getDay() !== sd.getDay()) return { blocked: false };
    if (!hourInRange(hour)) return { blocked: false };

    if (repeat === 'weekly') {
      return { blocked: true, title };
    }

    const w1 = getISOWeek(sd);
    const w2 = getISOWeek(slotStart);
    const parity =
      (w2 - w1 + (sd.getFullYear() !== slotStart.getFullYear() ? 104 : 0)) % 2;

    return parity === 0 ? { blocked: true, title } : { blocked: false };
  }

  if (repeat === 'monthly') {
    if (slotStart.getDate() !== sd.getDate()) return { blocked: false };
    if (!hourInRange(hour)) return { blocked: false };
    return { blocked: true, title };
  }

  return { blocked: false };
}

export function canCancelReservation({ date, hour, cancelLimitHours }) {
  const limit = Number(cancelLimitHours || 0);
  if (!Number.isFinite(limit) || limit <= 0) return true;

  const start = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    hour,
    0,
    0,
    0
  );
  const now = new Date();
  const diffMs = start.getTime() - now.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);

  return diffHours >= limit;
}